export default `
    precision highp float;
    precision highp int;

    uniform vec2 uResolution;
    uniform float uScale;
    uniform float uTranslateY;

    vec3 colorA = vec3(0.039,0.914,0.698); 
    vec3 colorB = vec3(0.239,0.267,0.961);
    vec3 colorC = vec3(0.804,0.184,0.549);
    vec3 colorD = vec3(0.98,0.22,0.192);
    vec3 colorE = vec3(0.973,0.827,0.137);

    void main() {

        // To get the uv right color
        vec2 st = gl_FragCoord.xy/uResolution.xy;

        // Get ratio
        float ratio = uResolution.x / uResolution.y;

        // Scale into gradient
        float s = uScale;

        // Scale X
        st.x -= .5;
        // Scale
        st.x*= s;
        // Reset offset
        st.x += .5;

        // Scale Y
        st.y -= .5;
        // Scale
        st.y*= s;
        // Reset offset
        st.y += .5;

        // Translate y uv
        st.y += uTranslateY * s;

        // Apply ratio
        st.y -= .5;
        // Scale
        st.y /= .5 * ratio;
        // Reset offset
        st.y += .5;

        // Gradient percent
        vec3 pct = vec3((st.x + st.y) * .5);

        // Mix gradients
        vec3 gradient1 = mix(colorA, colorB, pct);
        vec3 gradient2 = mix(colorB, colorC, pct);
        vec3 gradient3 = mix(colorC, colorD, pct);
        vec3 gradient4 = mix(colorD, colorE, pct);
        
        vec3 gradientMixA = mix(gradient1, gradient2, pct);
        vec3 gradientMixB = mix(gradient2, gradient3, pct);
        vec3 gradientMixC = mix(gradient3, gradient4, pct);
        
        vec3 color = mix(mix(gradientMixA, gradientMixB, pct), mix(gradientMixB, gradientMixC, pct), pct);
        
        // Apply color
        gl_FragColor = vec4(color, 1.0);
        
        // UV color
        //gl_FragColor = vec4(st.xy, 0.0, 1.0);
    }
`;
